import { render, staticRenderFns } from "./PaidServiceAgreementEn.vue?vue&type=template&id=89ca3d90&scoped=true"
import script from "./PaidServiceAgreementEn.vue?vue&type=script&lang=js"
export * from "./PaidServiceAgreementEn.vue?vue&type=script&lang=js"
import style0 from "./PaidServiceAgreementEn.vue?vue&type=style&index=0&id=89ca3d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ca3d90",
  null
  
)

export default component.exports